export default {"src":"/_next/static/media/crystal.ce2c822d.svg","height":68,"width":192,"blurWidth":0,"blurHeight":0};